import React from 'react';
import BaseClass from '@/pages/BaseClass';

import $ from 'jquery';
import {
	Result,
	Button,
} from 'antd'
import {
	CommonValue,
	ngUrl,
	pcUrl,
	confirm,
	message,
	notify,
	formatTime,
	getQuery,
	httpPost
} from '@/utils/Tools';

export default class App extends BaseClass
{
	constructor(props)
	{
		super(props);
		
		this.state={
			'payInfo':{},
		};
	}
	
	componentDidMount()
	{
		let query = getQuery();
		if(query['out_trade_no'])
		{
			//query['out_trade_no'] = '83514564120301884';
			let url = pcUrl('user','payInfo');
			let param = {
				'pay_sn':query['out_trade_no']
			};
			
			httpPost(url,param)
				.then(data=>{
					this.setState({
						'payInfo':data,
					});
				});
		}
		else if(query['order_sn'])
		{
			this.setState({
				'payInfo':{
					'order_sn':query['order_sn'],
					'type':1,
				},
			});
		}
	}
	
	render()
	{
		return (
			<div>
				{this.state.payInfo['type'] == 0 && (
					<Result
						status="success"
						title={"您已成功充值"+this.state.payInfo['charge_amount']+"元"}
						subTitle={(
							<>
								<div style={{'margin-top':'.5em'}}>
									{/* 订单编号: 2017182818828182881 */}
									入账：
									<span className="text-red"> {this.state.payInfo['income_amount']}元 </span>
									；
									支付时间：{formatTime('Y-m-d H:i:s')}
								</div>
							</>
						)}
						extra={[
							<Button type="primary" key="console" onClick={()=>this.props.history.push('/user/profile')}>
								我的资料
							</Button>,
							<Button key="console" onClick={()=>this.props.history.push('/user/charge')}>
								继续充值
							</Button>,
						]}
					/>
				)}
				{this.state.payInfo['type'] == 1 && (
					<Result
						status="success"
						title="您已成功支付订单"
						subTitle={(
							<>
								<div style={{'margin-top':'.5em'}}>
									订单编号: {this.state.payInfo['order_sn']} ; 支付时间：{formatTime('Y-m-d H:i:s')}
								</div>
							</>
						)}
						extra={[
							<Button type="primary" key="console" onClick={()=>this.props.history.push('/user/order')}>
								我的订单
							</Button>,
							<Button key="console" onClick={()=>this.props.history.push('/imageList')}>
								继续购物
							</Button>,
						]}
					/>
				)}
				{this.state.payInfo['type'] == 2 && (
					<Result
						status="success"
						title="您已经升级会员等级"
						subTitle={(
							<>
								<div style={{'margin-top':'.5em'}}>
									当前等级：
									<span className="text-red"> {this.state.payInfo['rank_name']} </span>
									;
									支付时间：{formatTime('Y-m-d H:i:s')}
								</div>
							</>
						)}
						extra={[
							<Button type="primary" key="console" onClick={()=>this.props.history.push('/user/rank')}>
								查看会员
							</Button>,
							<Button key="console" onClick={()=>this.props.history.push('/imageList')}>
								开始购物
							</Button>,
						]}
					/>
				)}
			</div>
		);
	}
}



